import random from 'lodash-es/random'

import { ISetStudioRecommendationsAction, TypeKeys } from '../searchPage'

const setStudioRecommendations = (config: any = {}) => {
  const maxItems = config.links_in_ad || 4
  const generation = config.generation
  const items = config.items || []
  const randomKeys = new Set()
  let randomItems

  // if there is less items in config than max number of items which should be randomly selected,
  // pick all of them
  if (items.length <= maxItems) {
    randomItems = items
  } else {
    // select random items from given config, by maxItems number
    while (randomKeys.size < maxItems) {
      randomKeys.add(random(0, items.length - 1))
    }
    randomItems = Array.from(randomKeys).map((key: number) => items[key])
  }

  const action: ISetStudioRecommendationsAction = {
    type: TypeKeys.SET_STUDIO_RECOMMENDATIONS,
    payload: {
      generation,
      items: randomItems
    }
  }

  return action
}

export default setStudioRecommendations
